import React, { ReactElement, useCallback, useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import makeStyles from '@mui/styles/makeStyles';
import { loadPdfWorker } from '@monorepo/shared/src/components/common/Pdf/util/pdf-util';

type Props = {
  url: string;
  printRef?: any;
  pageNumbers?: number[];
  printPreview?: boolean;
};

const PdfViewer = ({ url, printRef, pageNumbers, printPreview }: Props): ReactElement => {
  const { document, page, printPage } = useStyles();
  const [numberOfPages, setNumberOfPages] = useState<number>(0);

  useEffect(() => loadPdfWorker(pdfjs.version), []);

  const generateArrayOfPages = (numberOfPages) =>
    Array.from({ length: numberOfPages }, (_, idx) => idx + 1);

  const arrayOfPages = useCallback(() => {
    if (pageNumbers?.length) return pageNumbers;
    return generateArrayOfPages(numberOfPages);
  }, [pageNumbers, numberOfPages]);

  return (
    <div ref={printRef}>
      <Document
        file={url}
        className={!printPreview ? document : ''}
        loading={'loading...'}
        onLoadSuccess={({ numPages }) => setNumberOfPages(numPages)}
        renderMode="canvas"
      >
        {arrayOfPages().map((number) => (
          <Page
            key={`page-${number}`}
            pageNumber={number}
            className={!printPreview ? page : printPage}
            error={<>Error loading pdf...</>}
            loading={<></>}
            scale={1.25}
          />
        ))}
      </Document>
    </div>
  );
};

export default PdfViewer;

const useStyles = makeStyles(() => {
  return {
    document: {
      height: 'fit-content',
      minWidth: 'fit-content',
      border: '1px solid black',
    },
    page: {
      width: 'fit-content',
      margin: 'auto',
    },
    printPage: {
      height: '100%',
      width: 'auto !important',
      maxHeight: '100%',
      '& canvas:first-of-type': {
        height: '100% !important',
        width: 'auto !important',
        maxWidth: '100%',
        maxHeight: '100%',
      },
    },
  };
});
